import React, { Component } from 'react'
import connect from "react-redux/es/connect/connect";
import { Button, Layout, Spin } from "antd";

import Feed from "../Feed";
import PageHeader from "../../components/Modules/PageHeader";
import HeadingBar from "../../components/Modules/HeadingBar";
import FilterPanel from "../../components/Modules/FilterPanel";
import ChannelProfileSection from '../../components/Modules/ChannelProfileSection';
import ChannelPreview from '../../components/Modules/ChannelPreview';
import AskForLogin from '../../components/Modules/AskForLogin';

import { getSubscriptionsAction } from "../../actions/channelsStoreActions";

import Events from "../../services/events";

import './ChannelPage.less';

const { Content } = Layout;

class ChannelPage extends Component {
  state = {
    list: [],
    name: 'Channel',
    loading: true,
    loadingPlayer: true,
    showChat: false,
    askForLogin: false,
    activeType: 'auth',
    visibleRegistration: false,
    visibleAuth: true
  };

  static getDerivedStateFromProps(props, state) {
    const { userClaims } = props.user;
    if (userClaims !== state.userClaims) {
      props.getSubscriptionsAction();

      return {
        userClaims: userClaims,
        loading: false
      };
    }

    return null;
  }

  async componentDidMount() {
    this.setFilters();
  }

  setFilters() {
    Events.setFilter('events', 'all');
    Events.setSort('time', 'desc')
  }

  onSourceReady() {
    this.setState({ loadingPlayer: false })
  }

  setStateHandler(obj) {
    this.setState(obj);
  }

  render() {
    if (this.state.loading) return <Spin className="preloader" />;

    const { channels, events, subscriptions, subscribeOptions, user, params } = this.props;
    const { userClaims } = user;
    const { channelId } = params;
    const currentChannel = channels && channels.find(channel => channel.id === channelId);

    let upcomingEvents = [];
    let pastEvents = [];

    events.map(item => {
      if (item.channel && item.channel.id === channelId) {
        item.isUpcoming ? upcomingEvents.push(item) : pastEvents.push(item)
      }
    });

    let eventsCount = upcomingEvents.length + pastEvents.length;

    const subscribersNumber = subscriptions && Object.keys(subscriptions).reduce((result, next) => {
      const length = subscriptions[next].filter(subscription => subscription === channelId).length;
      return result + length;
    }, 0);

    const header = (
      <PageHeader
        className="header"
        backTo={"Channels"}
        pseudoBack={this.state.askForLogin ? this.setStateHandler : null}
        extra={
          <div className="search-form">
            <FilterPanel
              filter={this.filterBy}
              title="Channel search"
              type="channel"
              deviceType
            />
          </div>
        }
        extraMobile={
          <Button type="primary" shape="circle" icon="search" />
        }
        mobileTitleSearch="Channel search"
        mobileTypeSearch="channel"
      />
    );

    return(
      <Layout className="page-wrapper">
        {
          this.state.askForLogin ? (
            <Content className="feed">
              {header}
              <AskForLogin />
            </Content>
          ) : (
            <Content className="feed">
              {header}
              <div className="page-content-inner">
                {
                  currentChannel && (
                    <ChannelProfileSection
                      currentChannel={currentChannel}
                      eventsCount={eventsCount}
                      userClaims={userClaims}
                      subscribersNumber={subscribersNumber}
                      user={user}
                      subscriptions={subscriptions}
                      subscribeOptions={subscribeOptions}
                      setStateHandler={this.setStateHandler}
                    />
                  )
                }
              </div>

              {
                (upcomingEvents.length === 0 && pastEvents.length === 0) && (
                  <ChannelPreview
                    channelId={channelId}
                    claims={userClaims}
                    onSourceReady={this.onSourceReady}
                    showChat={this.state.showChat}
                    loadingPlayer={this.state.loadingPlayer}
                    setStateHandler={this.setStateHandler}
                  />
                )
              }

              {
                (upcomingEvents.length > 0) && (
                  <React.Fragment>
                    <HeadingBar
                      title={`Upcoming Events (${upcomingEvents.length})`}
                    />
                    <Feed
                      list={upcomingEvents}
                      caption={'Upcoming events'}
                      renderType={'events'}
                      location={this.props.location}
                    />
                  </React.Fragment>
                )
              }

              {
                (pastEvents.length > 0) && (
                  <React.Fragment>
                    <HeadingBar
                      title={`Past Events (${pastEvents.length})`}
                    />
                    <Feed
                      list={pastEvents}
                      caption={'Past events'}
                      renderType={'events'}
                      location={this.props.location}
                    />
                  </React.Fragment>
                )
              }
            </Content>
          )
        }
      </Layout>
    )
  }
}

export default connect(
  null,
  { getSubscriptionsAction }
)(ChannelPage);



// WEBPACK FOOTER //
// ./src/pages/ChannelPage/index.js